import { render, staticRenderFns } from "./SPKFormType.vue?vue&type=template&id=5099390e&"
import script from "./SPKFormType.vue?vue&type=script&lang=js&"
export * from "./SPKFormType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports